import { FC, memo, useMemo, useState } from 'react';
import qrPlaceholder from './qr-placeholder.png';
import { Typography } from '@mui/material';
import { css, cx } from '@emotion/css';
import { useTranslation } from 'react-i18next';

type Props = {
  url: string | null;
  format: string;
  qrCode?: string;
  qrCallToAction?: string;
};

/**
 * @deprecated
 */
const PreviewTablet: FC<Props> = ({ url, format, qrCode, qrCallToAction }) => {
  const [mediaUrl, setMediaUrl] = useState(url);
  const { t } = useTranslation();

  useMemo(() => {
    if (url !== mediaUrl) {
      setMediaUrl(null);
      setTimeout(() => {
        setMediaUrl(url);
      }, 500);
      return;
    }
    setMediaUrl(url);
  }, [url]);

  return (
    <div
      className={cx(
        'box-content p-5 bg-black',
        css`
          border-radius: 32px;
          width: 600px;
        `
      )}
    >
      <div
        className={cx(
          'relative w-full h-0 overflow-hidden bg-black',
          css`
            padding-top: 60%;
            border-radius: 16px;
          `
        )}
      >
        <div
          className={cx('absolute inset-x-0 inset-y-0 m-auto overflow-hidden', {
            'bg-slate-500': !mediaUrl,
            'bg-black': Boolean(mediaUrl),
          })}
        >
          {format.includes('image') && mediaUrl && (
            <img src={mediaUrl} className="object-contain w-full h-full" />
          )}
          {format.includes('video') && mediaUrl && (
            <video
              controls
              className="object-contain w-full h-full"
              loop
              muted
              autoPlay
            >
              <source src={mediaUrl} type="video/mp4" />
              Your browser does not support the video tag.
            </video>
          )}
          {!mediaUrl && (
            <div
              className={cx(
                'absolute w-full h-full top-0 left-0 flex justify-center items-center',
                css`
                  background-color: rgba(0, 0, 0, 0.5);
                  z-index: 2;
                `
              )}
            >
              <Typography
                variant="h6"
                sx={{
                  mb: '20px',
                  color: 'white',
                  textShadow: '0 2px 10px rgba(0,0,0,0.4)',
                }}
              >
                {t('preview.empty_media_text')}
              </Typography>
            </div>
          )}
          {qrCode && (
            <div
              className={cx(
                'absolute bg-white',
                css`
                  width: 10%;
                  right: 3%;
                  bottom: 5%;
                  z-index: 1;
                  border-radius: 3px;
                  overflow: hidden;
                `
              )}
            >
              {qrCallToAction && (
                <div
                  className={cx(
                    'uppercase',
                    css`
                      font-size: 6px;
                      padding: 3px 5px 0px 5px;
                    `
                  )}
                >
                  {qrCallToAction}
                </div>
              )}
              <img src={qrPlaceholder} />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

/**
 * @deprecated
 */
export default memo(PreviewTablet);
